import { useEffect } from 'react';
import { isMapFilterVisibleState, MapRef } from 'state/map';

export const useStreetViewVisibility = (mapRef: MapRef | null) => {
  const [, setIsMapFilterVisible] = isMapFilterVisibleState();

  useEffect(() => {
    if (mapRef) {
      const map = mapRef;
      const streetView = map.getStreetView();

      // Check if streetView is available before using it
      if (!streetView) {
        return () => {};
      }

      const handleStreetViewVisibleChange = () => {
        const visible = streetView.getVisible();
        setIsMapFilterVisible(!visible);
      };

      // Add the listener
      streetView.addListener('visible_changed', handleStreetViewVisibleChange);

      // Initial check
      handleStreetViewVisibleChange();

      // Cleanup listeners
      return () => {
        if (streetView) {
          google.maps.event.clearInstanceListeners(streetView);
        }
      };
    }

    // Return a no-op function when mapRef is null
    return () => {};
  }, [mapRef]);
};
